
import React, { useState, useRef } from "react";
import {
  Container, Typography, Button, Box, Dialog, DialogActions,
  DialogContent, DialogTitle, Slider, MenuItem, Select, FormControl,
} from "@mui/material";
import { getStimulus } from '../api/stimulusapi';
import { Mic, MicOff } from "@mui/icons-material";

const stimulusData = {
  ...getStimulus(),
  "Live Voice": { "Start Recording": "live" },
  "PB Words": { "word1": "/assets/audio/pb1.wav", "word2": "/assets/audio/pb2.wav", "word3": "/assets/audio/pb3.wav", "word4": "/assets/audio/pb4.wav", "word5": "/assets/audio/pb5.wav", "word6": "/assets/audio/pb6.wav", "word7": "/assets/audio/pb7.wav", "word8": "/assets/audio/pb8.wav", "word9": "/assets/audio/pb9.wav", "word10": "/assets/audio/pb10.wav", "word11": "/assets/audio/pb11.wav", "word12": "/assets/audio/pb12.wav", "word13": "/assets/audio/pb13.wav", "word14": "/assets/audio/pb14.wav", "word15": "/assets/audio/pb15.wav", "word16": "/assets/audio/pb16.wav", "word17": "/assets/audio/pb17.wav", "word18": "/assets/audio/pb18.wav", "word19": "/assets/audio/pb19.wav", "word20": "/assets/audio/pb20.wav", "word21": "/assets/audio/pb21.wav", "word22": "/assets/audio/pb22.wav", "word23": "/assets/audio/pb23.wav", "word24": "/assets/audio/pb24.wav", "word25": "/assets/audio/pb25.wav" }
};

const Conditioning = () => {
  const [step, setStep] = useState(1);
  const [selectedStimulus, setSelectedStimulus] = useState("Pure Tone");
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [volume, setVolume] = useState(0.5);
  const [audio, setAudio] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const [recordedAudio, setRecordedAudio] = useState(null);


  const nextStep = () => setStep((prev) => prev + 1);

  const playAudio = (freq) => {
    if (audio) audio.pause();
    if (selectedStimulus === "Live Voice") {
      toggleRecording();
    } else {
      const newAudio = new Audio(stimulusData[selectedStimulus][freq]);
      newAudio.volume = volume;
      newAudio.play();
      setAudio(newAudio);
      setSelectedFrequency(freq);
    }
  };
  const playSound = () => {
    const audio = new Audio("/assets/audio/1.wav"); // Replace with your actual sound file path
    audio.play();
    nextStep();
  };
  const toggleBluetooth = async () => {
    // Step 1: Check for Bluetooth API support
    if (!navigator.bluetooth) {
      alert("❌ Bluetooth is not supported on this device or browser.");
      return;
    }

    // Step 2: Request Bluetooth access
    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: ['battery_service'], // Example service
      });

      console.log("✅ Bluetooth Device Connected:", device.name);
      alert(`✅ Connected to: ${device.name}`);
    } catch (error) {
      console.error("Bluetooth connection error:", error);
      alert("❌ Bluetooth access denied. Please allow permissions.");
    }
  };

  const playRandomPBWord = () => {
    if (audio) audio.pause();
    const pbWords = Object.values(stimulusData["PB Words"]);
    const randomAudio = new Audio(pbWords[Math.floor(Math.random() * pbWords.length)]);
    randomAudio.volume = volume;
    randomAudio.play();
    setAudio(randomAudio);
  };
  const toggleRecording = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.error("getUserMedia is not supported in this browser.");
      alert("Microphone access is not supported in this browser. Please use a modern browser like Chrome or Edge.");
      return;
    }

    if (isRecording) {
      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
      }
      setIsRecording(false);
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);
        const audioChunks = [];

        mediaRecorder.ondataavailable = (event) => {
          audioChunks.push(event.data);
        };

        mediaRecorder.onstop = () => {
          const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
          const audioUrl = URL.createObjectURL(audioBlob);
          setRecordedAudio(audioUrl);
        };

        mediaRecorderRef.current = mediaRecorder;
        mediaRecorder.start();
        setIsRecording(true);
      } catch (error) {
        console.error("Error accessing microphone:", error);
        alert("Failed to access microphone. Please check your browser settings.");
      }
    }
  };


  return (
    <Container sx={{ textAlign: "center", mt: 2, p: 2, maxWidth: "400px", bgcolor: "#f5f5f5", borderRadius: 3 }}>
      {/* Step 1: Instruction Popup */}
      <Dialog open={step === 1} onClose={nextStep}>
        <DialogTitle>📢 Conditioning Instructions</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "12px", mb: 1 }}>1. The Environment should be quite.</Typography>
          <Typography sx={{ fontSize: "12px", mb: 1 }}>2. Kindly pair the Loudspeakers.</Typography>
          <Typography sx={{ fontSize: "12px", mb: 1 }}>3. Keep the loudspeaker on either side of the ear at a distance of 1 meter.The cone of loudspeaker should be at ear level.</Typography>
          <Typography sx={{ fontSize: "12px" }}>4. Keep/set the volume of the phone at the preffered level.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={nextStep} color="primary" variant="contained">Got it</Button>
        </DialogActions>
      </Dialog>

      {/* Step 2: Sound Check Popup */}
      <Dialog open={step === 2} onClose={nextStep}>
        <DialogTitle> 🔔 Alert</DialogTitle>
        <DialogContent>
          <Typography>Are you sure that bluetooth speaker is connected?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={playSound} color="primary" variant="contained">Yes</Button>
          <Button onClick={() => setStep(1)} color="error" variant="contained">No</Button>
        </DialogActions>
      </Dialog>

      {/* Step 3: Settings Confirmation */}
      <Dialog open={step === 3} onClose={nextStep}>
        <DialogTitle> 🔔 Alert</DialogTitle>
        <DialogContent>
          <Typography>Is this sound audible through your speaker?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={nextStep} color="primary" variant="contained">Yes</Button>
          <Button onClick={toggleBluetooth} color="secondary" variant="contained">
            Settings
          </Button>

        </DialogActions>
      </Dialog>

      {step >= 4 && (
        <>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, fontSize: "18px" }}>⚙️ Conditioning Settings</Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, fontSize: "15px" }}>Select the Stimulus</Typography>
            <Select value={selectedStimulus} onChange={(e) => setSelectedStimulus(e.target.value)}>
              {Object.keys(stimulusData).map((stimulus) => (
                <MenuItem key={stimulus} value={stimulus}>{stimulus}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {selectedStimulus === "PB Words" ? (
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" onClick={playRandomPBWord}>Play</Button>
            </Box>
          ) : (
            <>
              {selectedStimulus !== "Live Voice" && (
                <>

                  <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 1 }}>
                    {Object.keys(stimulusData[selectedStimulus]).map((freq) => (
                      <Button
                        key={freq}
                        variant={selectedFrequency === freq ? "contained" : "outlined"}
                        onClick={() => playAudio(freq)}
                      >
                        {freq}
                      </Button>
                    ))}
                  </Box>
                </>
              )}
            </>
          )}

          <Box sx={{ mt: 2, width: "100%" }}>
            <Typography>🔊 Adjust Volume</Typography>
            <Slider value={volume} min={0} max={1} step={0.1} onChange={(e, newValue) => setVolume(newValue)} />
          </Box>

          {selectedStimulus === "Live Voice" && (
            <Box sx={{ mt: 2 }}>
              {!recordedAudio && (
                <Button
                  variant="contained"
                  color={isRecording ? "error" : "primary"}
                  onClick={toggleRecording}
                  startIcon={isRecording ? <MicOff /> : <Mic />}
                >
                  {isRecording ? "Stop Recording" : "Start Recording"}
                </Button>
              )}

              {recordedAudio && (
                <Box sx={{ mt: 1, width: "200px", mx: "auto" }}>
                  <Typography>🎤 Recorded Audio</Typography>
                  <audio controls src={recordedAudio} style={{ width: "100%" }}></audio>
                </Box>

              )}
            </Box>
          )}

        </>
      )}
    </Container>
  );
};

export default Conditioning;